import axios from "axios";

export const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
};

export const dashboardFor = (role) =>
  ({ admin: "/control-room", staff: "/growth-desk", retail_owner: "/business-hub", affiliate: "/partner-hub", rider: "/rider" }[role] || "/style-hub");

export const getRefCode = () => localStorage.getItem("svk_ref") || "";
